import { RuleSchema } from '@/types/schema';

import { DocsButton } from '../DocsButton';
import { SESSION_RULE_CRUD_PANE_WIDTH } from '../EvaluatorCrudPane/constants';
import { SearchModel } from '../RunsTable/types';
import { SplitViewPane } from '../SplitViewPane';
import { SessionRulesCrudFormV2 } from './SessionRulesCrudFormV2';

export function RuleEditPane(props: {
  open: boolean;
  onClose: () => void;
  id?: string;
  sessionId: string;
  initialData?: RuleSchema;
  onSuccess: () => void;

  runTableFilters?: SearchModel;
  setRunTableFilters?: (model: SearchModel) => void;
}) {
  return (
    <SplitViewPane
      open={props.open}
      hideArrows
      onClose={props.onClose}
      title={
        <div className="flex w-full items-center justify-between">
          {props.initialData
            ? 'Edit Automation Rule'
            : 'Create Automation Rule'}
          <DocsButton link="https://docs.langchain.com/langsmith/rules" />
        </div>
      }
      defaultWidth={SESSION_RULE_CRUD_PANE_WIDTH}
    >
      {props.open && (
        <div className="flex flex-col gap-4 overflow-auto p-4">
          <SessionRulesCrudFormV2
            key={props.id}
            id={props.id}
            sessionId={props.sessionId}
            initialData={props.initialData}
            onSuccess={() => {
              props.onSuccess();
              props.onClose();
            }}
            runTableFilters={props.runTableFilters}
            setRunTableFilters={props.setRunTableFilters}
            onClose={props.onClose}
          />
        </div>
      )}
    </SplitViewPane>
  );
}
